//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { mergeQueryParamsWithDeepLink } from '~/utils/helpers';
import IconAppStoreUk from '~/assets/img/apps/app-store-uk.svg?inline';
import IconAppStoreEn from '~/assets/img/apps/app-store-en.svg?inline';
import IconGooglePlayUk from '~/assets/img/apps/google-play-uk.svg?inline';
import IconGooglePlayEn from '~/assets/img/apps/google-play-en.svg?inline';

export default {
  name: 'BaseLinkApp',
  components: {
    'app-store-uk': IconAppStoreUk,
    'app-store-en': IconAppStoreEn,
    'google-play-uk': IconGooglePlayUk,
    'google-play-en': IconGooglePlayEn,
  },
  props: {
    idAttr: {
      type: String,
      default: '',
    },
    link: {
      type: Object,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    isSmartLink: {
      type: Boolean,
      default: false,
    },
    queryParams: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('smart', ['url']),
    getIcon() {
      const icon = this.icon;
      const locale = this.$i18n.locale;

      return icon && `${icon}-${locale}`;
    },
    getSmartLink() {
      if (typeof this.url === 'string') {
        return typeof this.queryParams === 'object' && this.queryParams !== null
          ? mergeQueryParamsWithDeepLink(this.url, this.queryParams)
          : this.url;
      }

      return '';
    },
    smartLink() {
      return {
        id: "",
        url: this.getSmartLink,
        target: "_blank",
        linktype: "url",
        fieldtype: "multilink",
        cached_url: this.getSmartLink,
      };
    },
  },
}
